// Last-open-conversation bookmark — lets app launch land on the thread the
// operator was actually in, instead of a fresh empty conversation every boot.
//
// Written on every conversation switch AND on every send (so a brand-new
// thread the operator is typing in becomes the restore target once its first
// turn persists it server-side). Cleared when the bookmarked thread is
// archived. Consumed once at boot by restoreLastConversation()
// (chatStore.conversation.ts).
//
// localStorage access is defensive: jsdom tests and degraded browser modes
// (storage disabled) must never throw out of the store.

const KEY = 'onestone-last-conversation';

export function getLastConversationId(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastConversationId(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    // Storage unavailable — restore-on-boot simply won't happen. Non-fatal.
  }
}

export function clearLastConversationId(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Non-fatal — see setLastConversationId.
  }
}
